import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PersonalProfileComponent } from './components/personal-profile/personal-profile.component';
import { AdminUsersComponent } from './components/admin-users/admin-users.component';
import { AuthGuard } from '../shared/guards/auth.guard';

const routes: Routes = [
  {path:'personal-profile',component:PersonalProfileComponent,canActivate:[AuthGuard]},
  {path:'admin-users',component:AdminUsersComponent,canActivate:[AuthGuard],data:{role:'Administrador'}},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
